<template>
  <div>
    <div class="width-full float-left px-4 py-4">
      <transition-group name="list">
        <NewsItem v-for="news in dataTweets.slice(0,showCount)" :key="news._id" :record="news" />
      </transition-group>
    </div>
    <div v-if="dataTweets.length > 5" class="width-full float-left mb-3 pr-4">
        <div
        v-scroll-to="{el: '#calendar-row',offset: -100}"
          @click="showMore = true"
          class="more text-right"
          v-if="!showMore"
        >{{"Show more"}}</div>
        <div
        v-scroll-to="{el: '#calendar-row',offset: -100}"
          @click="showMore = false"
          class="more text-right"
          v-if="showMore"
        >Hide</div>
      </div>
    </div>
</template>


<script>
import NewsItem from "./miniTweetsItem";
export default {
  name: "miniNews",
  components: { NewsItem },
  props: ["dataTweets"],
  watch: {
    showMore(newVal) {
      if (newVal) {
        this.showCount = 999999;
      } else {
        this.showCount = 5;
      }
    }
  },
  data() {
    return {
      showCount: 5,
      showMore: false,
      tool: true,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" }
      ]
    };
  }
};
</script>

<style>
</style>